var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled } from 'styled-components';
var PageContainer = styled.div.withConfig({ displayName: "PageContainer", componentId: "sc-q5k1nq" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 992px;\n  margin: 0 auto;\n  color: ", ";\n"], ["\n  width: 992px;\n  margin: 0 auto;\n  color: ", ";\n"])), function (_a) {
    var t = _a.theme;
    return t.colors.black10;
});
export { PageContainer };
var templateObject_1;
